<template>
  <SimpleTable
    ref="regionalQuota"
    table-code="regionalQuota"
    :menus="['查询', '批量修改', '插入', '批量删除']"
    :bottomFrozenRowCount="1"
    :columns="columns"
    :data="tableData"
    :loading="loading"
    @modify-data-change="onModifyDataChange"
  />
</template>
<script>
import {
  sortRecords,
  addCbFn,
  getOptions,
  aggregationSUM,
  aggregationAmount
} from '@/utils/index'
import SimpleTable from '@/components/SimpleTable/index.vue'

export default {
  name: 'RegionalQuota',
  components: {
    SimpleTable
  },
  props: {
    billId: {
      type: String,
      default: ''
    },
    importRecordId: {
      type: String,
      default: ''
    },
    basicInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      columns: [
        { field: 'supplyType', title: '供应方式', aggregation: aggregationSUM },
        { field: 'name', title: '名称' },
        { field: 'spec', title: '规格型号' },
        { field: 'unit', title: '单位' },
        { field: 'quantity', title: '数量' },
        { field: 'rate', title: '单价' },
        { field: 'amount', title: '金额', aggregation: aggregationAmount },
        { field: 'keywords', title: '预算关键词' },
        { field: 'resourceName', title: '汇总表人材机' }
      ],
      tableData: [],
      loading: false
    }
  },
  watch: {
    billId() {
      this.getTableData()
    }
  },
  created() {
    this.getTableData()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    async getTableData() {
      this.loading = true
      const res = await this.$service.get(
        '/project-unit-budget/bill-item/cb-bill-resource/list',
        {
          billId: this.billId
        }
      )
      this.loading = false
      this.tableData = sortRecords(res?.data || [])
    },

    import(row) {
      if (!this.tableData[row]?.id) {
        this.$message.warning('请先保存该数据')
        return
      }
      this.$refs.details.show(this.tableData[row])
    },

    async onModifyDataChange(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        '/project-unit-budget/bill-item/cb-bill-resource/batch',
        getModifyData,
        cleanModifyData
      )

      this.getTableData()
    }
  }
}
</script>

<style scoped lang="less">
.list-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
